var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPicto || _vm.text)?_c('div',{class:[
    'd-flex py-05 px-1 justify-content-center align-items-center rounded-1 gmb-sticker',
    { 'gmb-sticker--alert': _vm.isAlert },
  ]},[_vm._t("default"),(_vm.text)?_c('FdText',{class:{ 'ml-1': _vm.hasPicto },attrs:{"colorWhite":"","fontSizeSmaller2":"","tag":"span"}},[_vm._v(_vm._s(_vm.text)+" ")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }